module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"googleCloudAccountsTable.projectId":"Project ID","googleCloudAccountsTable.dataSetId":"Dataset ID","googleCloudAccountsTable.expiry":"Expiry","googleCloudAccountsTable.noData":"No google cloud connections configured.","googleCloudAccountsTable.disconnectedUsageConnection":"Please update your usage connection with valid credentials"}}')
  delete Component.options._Ctor
}
